import { render, staticRenderFns } from "./Rename.vue?vue&type=template&id=8068cde4&"
import script from "./Rename.vue?vue&type=script&lang=js&"
export * from "./Rename.vue?vue&type=script&lang=js&"
import style0 from "./Rename.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports